import { Box } from "@mui/material";
import React from "react";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    
    return (
        <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
        >
        {value === index && <Box>{children}</Box>}
        </div>
    );
}

export default TabPanel;